import { c as _c } from "react/compiler-runtime";
import { TourCardPropertiesType } from "@website/accommodation-ui/tour-card";
import { TourCardRating } from "@website/accommodation-ui/tour-card/tour-card-hotel-rating";
import { MaterialIcon } from "@website/icons/material";
import { numberConvert } from "@website/utils/number-convert";
import Link from "next/link";
import { useRouter } from "next/router";
import { FC } from "react";
export const TourCardHotel: FC<TourCardPropertiesType> = properties => {
  const $ = _c(20);
  const {
    searchId,
    hotel,
    isDomestic,
    noFollow
  } = properties;
  let t0;
  if ($[0] !== hotel) {
    t0 = hotel || {};
    $[0] = hotel;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    stars,
    name,
    rating,
    reviewCount
  } = t0;
  const router = useRouter();
  const t1 = hotel?.id;
  let t2;
  if ($[2] !== isDomestic || $[3] !== router.query || $[4] !== searchId || $[5] !== t1) {
    t2 = {
      pathname: "/[origin]/[dest]/[id]",
      query: {
        ...router.query,
        id: searchId,
        hotelId: t1,
        isDomestic
      }
    };
    $[2] = isDomestic;
    $[3] = router.query;
    $[4] = searchId;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = noFollow ? "nofollow" : undefined;
  let t4;
  if ($[7] !== name) {
    t4 = <h2 className="line-clamp-1">{name}</h2>;
    $[7] = name;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <div className="flex items-center justify-between"><Link prefetch={false} href={t2} rel={t3}>{t4}</Link></div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== rating || $[14] !== reviewCount || $[15] !== stars) {
    t6 = stars || rating ? <div className="mt-2 flex items-center justify-between"><div>{stars && stars > 0 ? <div className="text-caption text-on-surface-high-emphasis flex items-center">{Array.from({
            length: stars
          }, _temp)}<div className="ms-1">{numberConvert(stars, {
              locale: "fa"
            })} ستاره</div></div> : null}</div><TourCardRating rating={rating} reviewCount={reviewCount} /></div> : null;
    $[13] = rating;
    $[14] = reviewCount;
    $[15] = stars;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <div className="px-4 pt-3">{t5}{t6}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
function _temp(_, index) {
  return <MaterialIcon key={`TourCardHotel-${index}`} name="star" />;
}